export default "__VITE_ASSET__CiS7q4C4__"